import { gql } from '@apollo/client'

const SEND_MFA_SMS_CODE = gql`
  mutation sendMfaSmsCode {
    sendMfaSmsCode {
      success
    }
  }
`

export default SEND_MFA_SMS_CODE
